module.exports = __webpack_public_path__ + "img/pure-ptfe-diaphragm.af156e42.png";